/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  document.addEventListener('DOMContentLoaded', function () {
    // Přeškrtnutá cena z metafieldu custom.applied_discount – zobrazení vypočtené a původní ceny
    (function variantCompareAtMetafield() {
      function applyMetafieldPrices(productEl, variantId) {
        if (!productEl || !variantId) return;
        const scriptEl = productEl.querySelector('[data-variant-compare-metafield]');
        if (!scriptEl) return;
        let map;
        try {
          map = JSON.parse(scriptEl.textContent);
        } catch (e) {
          console.error('[applied-discount] Neplatný JSON variant compare metafield', e);
          return;
        }
        const data = map[String(variantId)];
        const priceWrappers = productEl.querySelectorAll('[data-price-wrapper]');
        if (!data || !data.price || !data.compare) {
          var restoredPrice = null;
          var productJsonEl = productEl.querySelector('[data-product-json]');
          if (productJsonEl) {
            try {
              var productData = JSON.parse(productJsonEl.textContent);
              var variants = productData && productData.variants ? productData.variants : [];
              var matched = variants.find(function (v) {
                return String(v.id) === String(variantId);
              });
              if (matched && typeof matched.price === 'number') {
                var currencyApi = window.themeVendor && window.themeVendor.themeCurrency;
                var moneyFormat =
                  window.theme &&
                  (window.theme.settings && window.theme.settings.currency_code_enable
                    ? window.theme.moneyWithCurrencyFormat
                    : window.theme.moneyFormat);
                if (currencyApi && moneyFormat) {
                  restoredPrice = currencyApi.formatMoney(matched.price, moneyFormat);
                }
              }
            } catch (err) {
              console.error('[applied-discount] Nelze obnovit cenu z ProductJson', err);
            }
          }
          priceWrappers.forEach(function (wrap) {
            const compareEl = wrap.querySelector('[data-compare-price]');
            const priceEl = wrap.querySelector('[data-product-price]');
            const badgeEl = wrap.querySelector('.product-discount-badge');
            if (badgeEl) {
              badgeEl.style.display = 'none';
              badgeEl.textContent = '';
            }
            if (compareEl) {
              compareEl.textContent = '';
              compareEl.classList.add('hidden');
              compareEl.style.display = 'none';
            }
            if (priceEl) {
              priceEl.classList.remove('product__price--sale');
              if (restoredPrice && priceEl.textContent.trim() !== String(restoredPrice).trim()) {
                priceEl.textContent = restoredPrice;
              }
            }
          });
          return;
        }
        priceWrappers.forEach(function (wrap) {
          const compareEl = wrap.querySelector('[data-compare-price]');
          const priceEl = wrap.querySelector('[data-product-price]');
          const badgeEl = wrap.querySelector('.product-discount-badge');
          if (!compareEl || !priceEl) return;
          if (priceEl.textContent.trim() !== String(data.price).trim()) {
            priceEl.textContent = data.price;
          }
          priceEl.classList.add('product__price--sale');
          if (compareEl.textContent.trim() !== String(data.compare).trim()) {
            compareEl.textContent = data.compare;
          }
          compareEl.classList.remove('hidden');
          compareEl.style.display = '';
          if (badgeEl) {
            if (badgeEl.textContent !== (data.badge || '')) {
              badgeEl.textContent = data.badge || '';
            }
            badgeEl.style.backgroundColor = data.badge_color || '#c0504d';
            badgeEl.style.color = data.badge_text_color || '#fff';
            badgeEl.style.display = '';
          }
        });
      }

      function applyTextPodCenou(productEl, variantId) {
        if (!productEl || !variantId) return;
        var scriptEl = productEl.querySelector('[data-variant-text-pod-cenou]');
        if (!scriptEl) return;
        var map;
        try {
          map = JSON.parse(scriptEl.textContent);
        } catch (e) {
          console.error('[text-pod-cenou] Neplatný JSON', e);
          return;
        }
        var text = map[String(variantId)];
        var wrapper = productEl.querySelector('[data-variant-countdown-wrapper]');
        if (!wrapper) return;
        var customEl = wrapper.querySelector('[data-text-pod-cenou]');
        var countdownEl = wrapper.querySelector('[data-remaining-wrapper]');
        if (!customEl || !countdownEl) return;
        if (text) {
          customEl.textContent = text;
          customEl.classList.remove('hidden');
          countdownEl.classList.add('hidden');
        } else {
          customEl.textContent = '';
          customEl.classList.add('hidden');
          countdownEl.classList.remove('hidden');
        }
      }

      function applyUnitPricePleny(productEl, variantId) {
        if (!productEl || !variantId) return;
        var jsonEl = productEl.querySelector('[data-unit-pleny-json]');
        if (!jsonEl) return;
        var data;
        try {
          data = JSON.parse(jsonEl.textContent);
        } catch (e) {
          console.error('[unit-price-pleny] Neplatný JSON jednotkové ceny', e);
          return;
        }
        var entry = data[String(variantId)];
        var blocks = productEl.querySelectorAll('[data-unit-price-pleny]');
        blocks.forEach(function (blockEl) {
          var displayEl = blockEl.querySelector('[data-unit-pleny-display]');
          if (!entry || !entry.text) {
            if (entry && entry.discounted && !entry.color) {
              blockEl.style.display = '';
              blockEl.classList.add('product__unit-price--pleny-discounted');
              if (displayEl) {
                displayEl.textContent =
                  'Unit price error: discount_rule.badge_color missing (variant ' +
                  variantId +
                  ').';
                displayEl.classList.add('product__unit-price--pleny-error');
              }
              return;
            }
            blockEl.style.display = 'none';
            blockEl.classList.remove('product__unit-price--pleny-discounted');
            blockEl.style.removeProperty('--unit-pleny-discount-color');
            if (displayEl) {
              displayEl.textContent = '';
              displayEl.classList.remove('product__unit-price--pleny-error');
            }
            return;
          }
          blockEl.style.display = '';
          blockEl.setAttribute('data-variant-id', String(variantId));
          if (entry.discounted) {
            blockEl.classList.add('product__unit-price--pleny-discounted');
            if (!entry.color) {
              if (displayEl) {
                displayEl.textContent =
                  'Unit price error: discount_rule.badge_color missing (variant ' +
                  variantId +
                  ').';
                displayEl.classList.add('product__unit-price--pleny-error');
              }
              return;
            }
            blockEl.style.setProperty('--unit-pleny-discount-color', entry.color);
          } else {
            blockEl.classList.remove('product__unit-price--pleny-discounted');
            blockEl.style.removeProperty('--unit-pleny-discount-color');
          }
          if (displayEl) {
            displayEl.textContent = entry.text;
            displayEl.classList.remove('product__unit-price--pleny-error');
          }
        });
      }

      function scheduleApply(productEl, variantId) {
        if (!productEl || !variantId) return;
        var gen = (productEl._discountPriceGen || 0) + 1;
        productEl._discountPriceGen = gen;

        function run() {
          if (productEl._discountPriceGen !== gen) return;
          applyMetafieldPrices(productEl, variantId);
          applyTextPodCenou(productEl, variantId);
          applyUnitPricePleny(productEl, variantId);
        }

        // Hned + jeden sync po theme (bez MutationObserver — na WebKitu zamrzal QV).
        run();
        if (productEl._discountPriceTimers) {
          productEl._discountPriceTimers.forEach(clearTimeout);
        }
        productEl._discountPriceTimers = [
          setTimeout(run, 60),
          setTimeout(run, 180),
        ];
      }

      function syncProductEl(productEl) {
        if (!productEl) return;
        var idInput = productEl.querySelector('input[name="id"], select[name="id"]');
        var variantId = idInput && idInput.value;
        if (variantId) scheduleApply(productEl, variantId);
      }

      document.addEventListener('theme:variant:change', function (evt) {
        const variant = evt.detail && evt.detail.variant;
        if (!variant) return;
        const productEl = evt.target && evt.target.closest && evt.target.closest('[data-product]');
        if (productEl) {
          scheduleApply(productEl, variant.id);
        }
      });

      document.addEventListener(
        'change',
        function (evt) {
          var target = evt.target;
          if (!target || !target.closest) return;
          var productEl = target.closest('[data-product]');
          if (!productEl) return;
          if (!target.matches('input, select') && !(target.closest && target.closest('[data-option-position]'))) {
            return;
          }
          setTimeout(function () {
            var idInput = productEl.querySelector('input[name="id"], select[name="id"]');
            var variantId = idInput && idInput.value;
            if (variantId) scheduleApply(productEl, variantId);
          }, 0);
        },
        true
      );

      setTimeout(function () {
        document.querySelectorAll('[data-product]').forEach(syncProductEl);
      }, 150);

      var qvBodyClass = 'js-quick-view-visible';
      var wasQvVisible = false;
      var mo = new MutationObserver(function () {
        var visible = document.body.classList.contains(qvBodyClass);
        if (visible && !wasQvVisible) {
          document.querySelectorAll('.popup-quick-view [data-product]').forEach(syncProductEl);
        }
        wasQvVisible = visible;
      });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    })();

    // Dognet sale: S2S přes SuperApp webhook (ProcessDognetOrderWebhookJob).
    // Click attribution: assets/dognet-s2s.js → cart.attributes.dognet_visitor_id

    let isUpdating = false;
    let progressBarUpdatePending = false;
    let progressBarCartRequest = null;
    let cartDrawerCheckoutPriceTimeout = null;
    let cartProgressRefreshTimeout = null;
    const cartProgressOwnMutationSelectors = [
      '#discount-progress-container-product',
      '#discount-progress-container-drawer',
      '[data-cart-total-price]',
      '[data-cart-original-total-price]',
      '[data-left-to-spend]',
      '[data-message-default]',
      '[data-cart-message]'
    ];

    function initEmptyCartUpsellCarousel() {
      document.querySelectorAll('[data-empty-cart-upsell-carousel]').forEach(function (carousel) {
        const emptyMessage = carousel.closest('[data-empty-message]');

        if (emptyMessage && emptyMessage.classList.contains('hidden')) return;
        if (carousel.dataset.emptyCartUpsellInitialized === 'true') return;

        const track = carousel.querySelector('[data-empty-cart-upsell-track]');
        const slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-upsell-holder]'));
        const dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-empty-cart-upsell-dot]'));
        const prev = carousel.querySelector('[data-empty-cart-upsell-prev]');
        const next = carousel.querySelector('[data-empty-cart-upsell-next]');

        if (!track || slides.length === 0) {
          console.error('Empty cart upsell carousel error: track or slides are missing.');
          return;
        }

        carousel.dataset.emptyCartUpsellInitialized = 'true';

        function setActiveDot(index) {
          dots.forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
            dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
          });
        }

        function goToSlide(index) {
          const boundedIndex = Math.max(0, Math.min(index, slides.length - 1));

          track.scrollTo({
            left: slides[boundedIndex].offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });
          setActiveDot(boundedIndex);
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goToSlide(Number(dot.dataset.emptyCartUpsellDot));
          });
        });

        if (prev) {
          prev.addEventListener('click', function () {
            const activeIndex = dots.findIndex(function (dot) {
              return dot.classList.contains('is-active');
            });
            goToSlide(activeIndex <= 0 ? slides.length - 1 : activeIndex - 1);
          });
        }

        if (next) {
          next.addEventListener('click', function () {
            const activeIndex = dots.findIndex(function (dot) {
              return dot.classList.contains('is-active');
            });
            goToSlide(activeIndex >= slides.length - 1 ? 0 : activeIndex + 1);
          });
        }
      });
    }

    function debouncedUpdateProgressBar() {
      if (isUpdating) {
        progressBarUpdatePending = true;
        return;
      }

      isUpdating = true;
      updateAllProgressBars();
      setTimeout(() => {
        isUpdating = false;
        if (progressBarUpdatePending) {
          progressBarUpdatePending = false;
          debouncedUpdateProgressBar();
        }
      }, 500);
    }

    function loadProgressBarCart() {
      if (progressBarCartRequest) return progressBarCartRequest;

      progressBarCartRequest = fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(response => {
          return response.text().then(body => {
            if (!response.ok) {
              throw new Error('/cart.js returned HTTP ' + response.status + ': ' + body.slice(0, 120));
            }

            try {
              return JSON.parse(body);
            } catch (error) {
              throw new Error('/cart.js returned invalid JSON: ' + error.message + '. Response starts with: ' + body.slice(0, 120));
            }
          });
        })
        .finally(() => {
          progressBarCartRequest = null;
        });

      return progressBarCartRequest;
    }

    function showProgressBarCartError(error) {
      const errorMessage = 'Progress bar error: unable to load /cart.js (' + error.message + ').';
      console.error(errorMessage, error);

      ['discount-progress-text-product', 'discount-progress-text-drawer'].forEach(textId => {
        const text = document.getElementById(textId);
        if (text) text.textContent = errorMessage;
      });
    }

    function updateProgressBarElement(cart, containerId, fillId, textId) {
      const container = document.getElementById(containerId);
      if (!container) return;

      const threshold = Number(container.dataset.threshold);
      const discountType = container.dataset.discountType;
      const discountValue = Number(container.dataset.discountValue);
      const ctaTemplate = container.querySelector('[data-progress-bar-cta-template]');
      const successTemplate = container.querySelector('[data-progress-bar-success-template]');

      const fill = document.getElementById(fillId);
      const text = document.getElementById(textId);
      const barProduct = container.querySelector('#progress-bar-product');
      const barDrawer = container.querySelector('#progress-bar-drawer');

      function updateProductThresholdState(isThresholdReached) {
        if (containerId !== 'discount-progress-container-product') return true;

        const widget = container.closest('#discount-widget');
        const currentHeader = document.querySelector('[data-progress-current-discount-header]');
        const currentDiscountValue = currentHeader ? currentHeader.querySelector('[data-progress-current-discount-value]') : null;
        const currentDiscountPrice = currentHeader ? currentHeader.querySelector('[data-progress-current-discount-price]') : null;
        const widgetHeading = widget ? widget.querySelector('[data-progress-widget-heading]') : null;
        const discountTiers = widget ? widget.querySelector('[data-progress-discount-tiers]') : null;

        if (currentDiscountValue) {
          const discountText = isThresholdReached
            ? currentDiscountValue.dataset.progressAfterThresholdDiscount
            : currentDiscountValue.dataset.progressBeforeThresholdDiscount;

          if (!discountText) {
            const errorMessage = 'Progress bar configuration error: current discount threshold text is missing.';
            console.error(errorMessage);
            if (text) text.textContent = errorMessage;
            return false;
          }

          currentDiscountValue.textContent = discountText;
        }

        if (currentDiscountPrice) {
          const priceText = isThresholdReached
            ? currentDiscountPrice.dataset.progressAfterThresholdPrice
            : currentDiscountPrice.dataset.progressBeforeThresholdPrice;

          if (!priceText) {
            const errorMessage = 'Progress bar configuration error: current discount threshold price is missing.';
            console.error(errorMessage);
            if (text) text.textContent = errorMessage;
            return false;
          }

          currentDiscountPrice.textContent = priceText;
        }

        if (widgetHeading) widgetHeading.style.display = isThresholdReached ? 'none' : '';
        if (discountTiers) discountTiers.style.display = isThresholdReached ? 'none' : '';

        return true;
      }

      const missingConfig = [];
      if (!discountType) missingConfig.push('data-discount-type');
      if (!Number.isFinite(discountValue)) missingConfig.push('data-discount-value');
      if (!ctaTemplate || ctaTemplate.innerHTML.trim() === '') missingConfig.push('data-progress-bar-cta-template');
      if (!successTemplate || successTemplate.innerHTML.trim() === '') missingConfig.push('data-progress-bar-success-template');

      if (missingConfig.length > 0) {
        const errorMessage = 'Progress bar configuration error: missing ' + missingConfig.join(', ') + '.';
        console.error(errorMessage);
        if (text) text.textContent = errorMessage;
        return;
      }

      if (!Number.isFinite(threshold) || threshold <= 0) {
        const errorMessage = 'Progress bar configuration error: data-threshold must be a positive number.';
        console.error(errorMessage);
        if (text) text.textContent = errorMessage;
        return;
      }

      function formatCurrencyFromSubunits(amount, currency) {
        return new Intl.NumberFormat(document.documentElement.lang || navigator.language, {
          style: 'currency',
          currency
        }).format(amount / 100);
      }

      function renderProgressText(templateHtml, replacements) {
        return Object.keys(replacements).reduce((html, placeholder) => {
          return html.split(placeholder).join(replacements[placeholder]);
        }, templateHtml);
      }

      const currency = cart.currency;

      if (!currency) {
        const errorMessage = 'Progress bar error: cart.currency is missing from /cart.js.';
        console.error(errorMessage);
        if (text) text.textContent = errorMessage;
        return;
      }

      const originalTotal = cart.original_total_price;
      if (!Number.isFinite(originalTotal)) {
        const errorMessage = 'Progress bar error: cart.original_total_price is missing from /cart.js.';
        console.error(errorMessage);
        if (text) text.textContent = errorMessage;
        return;
      }

      const progress = Math.min((originalTotal / threshold) * 100, 100);
      const remaining = threshold - originalTotal;
      const discountDisplay = discountType === 'percent'
        ? `${discountValue}%`
        : formatCurrencyFromSubunits(discountValue, currency);

      if (fill) fill.style.width = `${progress}%`;

      if (originalTotal >= threshold) {
        if (!updateProductThresholdState(true)) return;
        if (barProduct) barProduct.style.display = 'none';
        if (barDrawer) barDrawer.style.display = 'none';
        if (text) {
          text.innerHTML = renderProgressText(successTemplate.innerHTML, {
            '[discount]': '<span class="progress-bar-placeholder">' + discountDisplay + '</span>'
          });
        }
      } else {
        if (!updateProductThresholdState(false)) return;
        if (barProduct) barProduct.style.display = '';
        if (barDrawer) barDrawer.style.display = '';
        if (text) {
          text.innerHTML = renderProgressText(ctaTemplate.innerHTML, {
            '[remaining]': '<span class="progress-bar-placeholder">' + formatCurrencyFromSubunits(remaining, currency) + '</span>',
            '[discount]': '<span class="progress-bar-placeholder">' + discountDisplay + '</span>',
            '[currency]': ''
          });
        }
      }
    }

    function updateAllProgressBars() {
      const hasProgressBar = document.getElementById('discount-progress-container-product') ||
        document.getElementById('discount-progress-container-drawer');

      if (!hasProgressBar) return;

      loadProgressBarCart()
        .then(cart => {
          updateProgressBarElement(cart, 'discount-progress-container-product', 'discount-progress-fill-product', 'discount-progress-text-product');
          updateProgressBarElement(cart, 'discount-progress-container-drawer', 'discount-progress-fill-drawer', 'discount-progress-text-drawer');
        })
        .catch(error => {
          showProgressBarCartError(error);
        });
    }

    function setCartDrawerCheckoutPriceError(message) {
      const drawer = document.getElementById('cart-drawer');

      console.error(message);
      if (drawer) drawer.dataset.cartCheckoutPriceError = message;
    }

    function formatCartDynamicPrice(amount, currency, withCurrency = true) {
      if (!Number.isFinite(amount)) {
        throw new Error('cart price amount is missing from /cart.js.');
      }
      if (!currency) {
        throw new Error('cart.currency is missing from /cart.js.');
      }

      if (window.themeVendor && window.themeVendor.themeCurrency && window.theme) {
        return window.themeVendor.themeCurrency.formatMoney(
          amount,
          withCurrency ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat
        );
      }

      return new Intl.NumberFormat(document.documentElement.lang || navigator.language, {
        style: 'currency',
        currency: currency
      }).format(amount / 100);
    }

    function formatCartFreeShippingRemaining(amount, currency) {
      let remaining = formatCartDynamicPrice(amount, currency, false);

      if (remaining.endsWith('.00') || remaining.endsWith(',00')) {
        remaining = remaining.slice(0, -3);
      }

      if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable) {
        remaining += ` ${window.theme.current_iso_code || currency}`;
      }

      return remaining;
    }

    function updateCartFreeShippingMessages(cart) {
      const total = cart.total_price;
      const currency = cart.currency;

      if (!Number.isFinite(total)) return;

      document.querySelectorAll('[data-cart-message][data-limit]').forEach(message => {
        const limit = Number(message.dataset.limit);
        if (!Number.isFinite(limit) || limit <= 0) return;

        const limitSubunits = Math.round(limit * 100);
        const remaining = Math.max(limitSubunits - total, 0);
        const progress = Math.min((total / limitSubunits) * 100, 100);
        const hasSuccessMessage = message.dataset.cartMessage === 'true';
        const defaultMessage = message.querySelector('[data-message-default]');
        const leftToSpend = message.querySelector('[data-left-to-spend]');

        if (leftToSpend) {
          try {
            leftToSpend.textContent = formatCartFreeShippingRemaining(remaining, currency);
          } catch (error) {
            setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: ' + error.message);
          }
        }

        message.classList.toggle('is-success', hasSuccessMessage && total >= limitSubunits && total !== 0);
        message.classList.toggle('is-hidden', total === 0);
        if (defaultMessage) {
          defaultMessage.classList.toggle('is-hidden', hasSuccessMessage && total >= limitSubunits);
        }

        message.querySelectorAll('[data-cart-message-progress]').forEach((progressElement, index) => {
          progressElement.classList.toggle('is-hidden', progress >= 100);
          progressElement.style.setProperty('--progress-width', `${progress}%`);
          if (index === 0) {
            progressElement.setAttribute('value', progress);
          }
        });
      });
    }

    function updateCartDynamicTotals(cart) {
      const total = cart.total_price;
      const originalTotal = cart.original_total_price;
      const currency = cart.currency;

      if (!Number.isFinite(total)) {
        setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: cart.total_price is missing from /cart.js.');
        return;
      }
      if (!Number.isFinite(originalTotal)) {
        setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: cart.original_total_price is missing from /cart.js.');
        return;
      }

      let totalText;
      try {
        if (total === 0) {
          if (!window.theme || !window.theme.strings || !window.theme.strings.free) {
            throw new Error('window.theme.strings.free is missing.');
          }
          totalText = window.theme.strings.free;
        } else {
          totalText = formatCartDynamicPrice(total, currency);
        }
      } catch (error) {
        setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: ' + error.message);
        return;
      }

      document.querySelectorAll('[data-cart-total-price]').forEach(totalPrice => {
        if (totalPrice.textContent !== totalText) {
          totalPrice.textContent = totalText;
        }
      });

      document.querySelectorAll('[data-cart-total]').forEach(totalValue => {
        totalValue.dataset.cartTotal = String(total);
      });

      if (originalTotal > total) {
        let originalText;
        try {
          originalText = formatCartDynamicPrice(originalTotal, currency);
        } catch (error) {
          setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: ' + error.message);
          return;
        }

        document.querySelectorAll('[data-cart-original-total-price]').forEach(originalPrice => {
          if (originalPrice.textContent !== originalText) {
            originalPrice.textContent = originalText;
          }
          originalPrice.classList.remove('hidden');
        });
      } else {
        document.querySelectorAll('[data-cart-original-total-price]').forEach(originalPrice => {
          originalPrice.textContent = '';
          originalPrice.classList.add('hidden');
        });
      }

      updateCartFreeShippingMessages(cart);
    }

    function updateCartDynamicTotalsFromCart() {
      if (!document.querySelector('[data-cart-total-price], [data-cart-message][data-limit]')) return;

      loadProgressBarCart()
        .then(cart => {
          updateCartDynamicTotals(cart);
        })
        .catch(error => {
          setCartDrawerCheckoutPriceError('Cart dynamic subtotal error: unable to load /cart.js (' + error.message + ').');
        });
    }

    function debouncedUpdateCartDynamicTotals() {
      if (cartDrawerCheckoutPriceTimeout) {
        clearTimeout(cartDrawerCheckoutPriceTimeout);
      }

      cartDrawerCheckoutPriceTimeout = setTimeout(() => {
        cartDrawerCheckoutPriceTimeout = null;
        updateCartDynamicTotalsFromCart();
      }, 250);
    }

    function refreshCartProgressState() {
      debouncedUpdateProgressBar();
      debouncedUpdateCartDynamicTotals();
    }

    function refreshCartProgressStateAfterCartUpdate() {
      if (cartProgressRefreshTimeout) {
        clearTimeout(cartProgressRefreshTimeout);
      }

      cartProgressRefreshTimeout = setTimeout(() => {
        cartProgressRefreshTimeout = null;
        refreshCartProgressState();
      }, 800);
    }

    function isCartProgressOwnMutation(mutation) {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      return target && cartProgressOwnMutationSelectors.some(selector => target.closest(selector));
    }

    const cartObserver = new MutationObserver((mutations) => {
      const isRelevantMutation = mutations.some(mutation => {
        return !isCartProgressOwnMutation(mutation);
      });
      if (isRelevantMutation) {
        refreshCartProgressState();
      }
    });

    function observeCartChanges(selector) {
      document.querySelectorAll(selector).forEach(target => {
        cartObserver.observe(target, { childList: true, subtree: true, attributes: false });
      });
    }

    observeCartChanges('#cart-drawer');
    observeCartChanges('#kosik');
    observeCartChanges('.product__form[action="/cart/add"]');

    document.addEventListener('theme:cart:loaded', refreshCartProgressState);
    document.addEventListener('theme:cart:added', refreshCartProgressState);
    document.addEventListener('theme:cart:open', refreshCartProgressState);
    document.addEventListener('theme:cart:update', refreshCartProgressStateAfterCartUpdate);
    document.addEventListener('theme:cart:added', function () {
      setTimeout(initEmptyCartUpsellCarousel, 300);
    });
    document.addEventListener('theme:cart:update', function () {
      setTimeout(initEmptyCartUpsellCarousel, 300);
    });

    // Initial load
    initEmptyCartUpsellCarousel();
    updateAllProgressBars();
    updateCartDynamicTotalsFromCart();
  });

  document.addEventListener('DOMContentLoaded', function () {

    if (window.innerWidth <= 767) {
      const sidebar = document.querySelector('.customer-account .sidebar');
      const sidebarList = sidebar.querySelector('ul');

      // Create and append navigation buttons
      const prevButton = document.createElement('button');
      prevButton.className = 'sidebar-nav-button sidebar-prev';
      prevButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const nextButton = document.createElement('button');
      nextButton.className = 'sidebar-nav-button sidebar-next';
      nextButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      sidebar.insertBefore(prevButton, sidebarList);
      sidebar.appendChild(nextButton);

      // Scroll handling
      const scrollAmount = sidebarList.offsetWidth * 0.8; // 50% of container width

      prevButton.addEventListener('click', () => {
        sidebarList.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        sidebarList.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });

      // Update button visibility
      const updateButtonVisibility = () => {
        prevButton.classList.toggle('hidden', sidebarList.scrollLeft <= 0);
        nextButton.classList.toggle('hidden',
          sidebarList.scrollLeft + sidebarList.offsetWidth >= sidebarList.scrollWidth);
      };

      sidebarList.addEventListener('scroll', updateButtonVisibility);
      window.addEventListener('resize', updateButtonVisibility);
      updateButtonVisibility();
    }

    // Address Manager
    class AddressManager {
      constructor() {
        this.initializeElements();
        this.bindEvents();
        this.initializeCountryProvinceSelectors();
      }

      initializeElements() {
        // Modals
        this.newAddressModal = document.querySelector('.js-modal');
        this.editAddressModal = document.querySelector('.js-edit-modal');

        // Buttons
        this.newAddressButton = document.querySelector('.js-address-new');
        this.editButtons = document.querySelectorAll('.js-edit-address');
        this.deleteButtons = document.querySelectorAll('.js-delete-address');
        this.closeButtons = document.querySelectorAll('.js-modal-close');

        // Forms
        this.editForms = document.querySelectorAll('.js-edit-form');

        // Add modal content selections
        this.newModalContent = document.querySelector('.js-modal-content');
        this.editModalContent = document.querySelector('.js-edit-modal-content');
      }

      bindEvents() {
        // New address
        if (this.newAddressButton) {
          this.newAddressButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.showModal(this.newAddressModal);
          });
        }

        // Edit addresses
        this.editButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const formId = button.getAttribute('data-form-id');
            const form = document.querySelector(`#EditAddress_${formId}`);
            if (form) {
              this.showEditForm(form);
              console.log('Edit button clicked', { formId, form, modal: this.editAddressModal });
            }
          });
        });

        // Delete addresses
        this.deleteButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const formId = button.getAttribute('data-form-id');
            if (confirm(this.newAddressModal.getAttribute('data-confirm-message'))) {
              const deleteForm = document.createElement('form');
              deleteForm.method = 'POST';
              deleteForm.action = `/account/addresses/${formId}`;

              const methodInput = document.createElement('input');
              methodInput.type = 'hidden';
              methodInput.name = '_method';
              methodInput.value = 'delete';

              const authenticityInput = document.createElement('input');
              authenticityInput.type = 'hidden';
              authenticityInput.name = 'authenticity_token';
              authenticityInput.value = window.Shopify?.routes?.authenticity_token || '';

              deleteForm.appendChild(methodInput);
              deleteForm.appendChild(authenticityInput);
              document.body.appendChild(deleteForm);
              deleteForm.submit();
            }
          });
        });

        // Close modals
        this.closeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = button.closest('.modal');
            if (modal) {
              this.hideModal(modal);
            }
          });
        });

        // Close on outside click and ESC key
        window.addEventListener('click', (e) => {
          if (e.target.classList.contains('modal')) {
            this.hideModal(e.target);
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            const activeModal = document.querySelector('.modal.active');
            if (activeModal) {
              this.hideModal(activeModal);
            }
          }
        });
      }

      initializeCountryProvinceSelectors() {
        const countrySelectors = document.querySelectorAll('.js-country-selector');

        countrySelectors.forEach(selector => {
          const formId = selector.getAttribute('data-form-id') || 'New';
          const provinceSelector = document.getElementById(`AddressProvince_${formId}`);
          const provinceWrapper = selector.closest('form').querySelector('.js-province-wrapper');

          if (provinceSelector && provinceWrapper) {
            const defaultCountry = selector.getAttribute('data-default');
            const defaultProvince = provinceSelector.getAttribute('data-default');

            if (defaultCountry) {
              this.updateProvinceSelect(selector, provinceSelector, provinceWrapper, defaultProvince);
            }

            selector.addEventListener('change', () => {
              this.updateProvinceSelect(selector, provinceSelector, provinceWrapper);
            });
          }
        });
      }

      updateProvinceSelect(countrySelect, provinceSelect, wrapper, defaultValue = null) {
        const provinces = window.Shopify.countries[countrySelect.value] || {};
        const provinceArray = Object.entries(provinces).map(([code, [name]]) => ({
          code,
          name
        }));

        provinceSelect.innerHTML = '';

        if (provinceArray.length) {
          provinceArray.forEach(province => {
            const option = document.createElement('option');
            option.value = province.code;
            option.textContent = province.name;
            provinceSelect.appendChild(option);
          });

          if (defaultValue) {
            provinceSelect.value = defaultValue;
          }

          wrapper.style.display = '';
        } else {
          wrapper.style.display = 'none';
        }
      }

      showModal(modal) {
        if (!modal) return;

        modal.classList.remove('hidden');
        modal.classList.add('active');

        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.add('active');
        }

        document.body.style.overflow = 'hidden';
      }

      hideModal(modal) {
        if (!modal) return;

        modal.classList.remove('active');

        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.remove('active');
        }

        document.body.style.overflow = '';

        const form = modal.querySelector('form');
        if (form) {
          form.reset();
        }
      }

      showEditForm(form) {
        const modal = this.editAddressModal;
        if (!modal) {
          console.error('Edit modal not found');
          return;
        }

        const formId = form.getAttribute('data-form-id');
        const originalForm = document.getElementById(`EditAddress_${formId}`);

        // Show modal and add active classes
        modal.style.display = 'flex';
        modal.classList.remove('hidden');
        modal.classList.add('active');

        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.add('active');
        }

        const modalBody = modal.querySelector('.modal-body');
        if (!modalBody) {
          console.error('Modal body not found');
          return;
        }

        const formClone = originalForm.cloneNode(true);
        formClone.classList.remove('is-hidden');
        formClone.style.display = 'block';

        const formElement = formClone.querySelector('form');
        if (formElement) {
          formElement.action = `/account/addresses/${formId}`;
        }

        modalBody.innerHTML = '';
        modalBody.appendChild(formClone);

        // Add class to body to prevent scrolling
        document.body.classList.add('modal-open');

        // Initialize country/province selectors
        const countrySelect = formClone.querySelector(`#AddressCountry_${formId}`);
        if (countrySelect) {
          const provinceSelect = formClone.querySelector(`#AddressProvince_${formId}`);
          const provinceContainer = formClone.querySelector(`#AddressProvinceContainer_${formId}`);

          if (provinceSelect && provinceContainer) {
            const defaultCountry = countrySelect.getAttribute('data-default');
            const defaultProvince = provinceSelect.getAttribute('data-default');

            if (defaultCountry) {
              countrySelect.value = defaultCountry;
              this.updateProvinceSelect(countrySelect, provinceSelect, provinceContainer, defaultProvince);
            }

            countrySelect.addEventListener('change', () => {
              this.updateProvinceSelect(countrySelect, provinceSelect, provinceContainer);
            });
          }
        }
      }
    }

    // Initialize AddressManager if we're on the addresses page
    if (document.querySelector('.js-modal')) {
      new AddressManager();
    }
  }); // Konec prvního document.addEventListener('DOMContentLoaded')

  // Multipack galerie: MP fotky nahoře; sync při variant change (event jde ze section, ne z [data-product]).
  (function initMultipackGallery() {
    var STYLE_ID = 'kolorky-multipack-gallery-style';
    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        '.product-single__media-slide.media--multipack-hidden,' +
        '.product-single__thumbnail.media--multipack-hidden{' +
        'display:none!important;}';
      document.head.appendChild(style);
    }

    function resolveProductEl(fromNode) {
      if (!fromNode) return null;
      if (fromNode.closest) {
        var direct = fromNode.closest('[data-product]');
        if (direct) return direct;
      }
      if (fromNode.querySelector) return fromNode.querySelector('[data-product]');
      return null;
    }

    function featuredMediaId(variant) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
      if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
      return null;
    }

    function mediaIdFromMap(gallery, variant) {
      var mapEl = gallery.querySelector('[data-multipack-variant-media-map]');
      if (!mapEl) return featuredMediaId(variant);
      try {
        var map = JSON.parse(mapEl.textContent);
        var mapped = map[String(variant.id)];
        if (mapped != null) return String(mapped);
      } catch (err) {
        console.error('[multipack-gallery] Neplatná variant→media mapa:', err);
      }
      return featuredMediaId(variant);
    }

    function productFeaturedMediaId(gallery) {
      var id = gallery && gallery.getAttribute('data-product-featured-media-id');
      return id ? String(id) : null;
    }

    function multipackQtyFromSku(sku) {
      var s = String(sku || '');
      var idx = s.lastIndexOf('_MP');
      if (idx === -1) return 0;
      var num = s.slice(idx + 3);
      if (!/^\d+$/.test(num)) return 0;
      var qty = parseInt(num, 10);
      return qty > 0 ? qty : 0;
    }

    function isMultipackVariant(variant) {
      return multipackQtyFromSku(variant && variant.sku) > 0;
    }

    var scrollLockUntil = 0;
    var scrollLockY = 0;
    var nativeScrollTo = window.scrollTo.bind(window);
    window.scrollTo = function () {
      if (Date.now() < scrollLockUntil) {
        return nativeScrollTo({ top: scrollLockY, left: 0, behavior: 'auto' });
      }
      return nativeScrollTo.apply(window, arguments);
    };

    function rememberScroll(productEl) {
      // Desktop tall layout scrolluje na variant image — lock jen na mobilu (Flickity jump).
      if (window.innerWidth >= 1024) return;
      if (!productEl || !productEl.querySelector('[data-multipack-gallery="true"]')) return;
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      scrollLockUntil = Date.now() + 900;
      productEl.dataset.multipackScrollY = String(scrollLockY);
    }

    function restoreScroll(productEl) {
      if (window.innerWidth >= 1024) return;
      if (!productEl || productEl.dataset.multipackScrollY == null) return;
      var y = parseInt(productEl.dataset.multipackScrollY, 10);
      delete productEl.dataset.multipackScrollY;
      if (Number.isNaN(y)) return;
      scrollLockY = y;
      scrollLockUntil = Date.now() + 900;
      nativeScrollTo({ top: y, left: 0, behavior: 'auto' });
    }

    function getFlickityLib() {
      if (typeof Flickity !== 'undefined' && Flickity && Flickity.data) return Flickity;
      if (
        window.themeVendor &&
        window.themeVendor.Flickity &&
        window.themeVendor.Flickity.data
      ) {
        return window.themeVendor.Flickity;
      }
      return null;
    }

    function getFlickityInstance(slider) {
      var F = getFlickityLib();
      if (!slider || !F) return null;
      var flkty = F.data(slider);
      return flkty && flkty.isActive ? flkty : null;
    }

    function setMultipackVisibility(nodes, showId) {
      nodes.forEach(function (node) {
        var mediaId = String(node.getAttribute('data-id') || '');
        var show = showId != null && mediaId === showId;
        node.hidden = !show;
        node.classList.toggle('media--multipack-hidden', !show);
        if (show) {
          node.classList.remove('media--hidden');
          forceMediaImages(node);
        }
      });
    }

    // Thumbs/slidy s loading=lazy ve display:none se na iOS po odkrýtí často nenačtou.
    function forceMediaImages(node) {
      if (!node) return;
      var imgs = node.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (img.getAttribute('loading') === 'lazy') {
          img.setAttribute('loading', 'eager');
        }
        if (img.complete && img.naturalWidth > 0) continue;

        var srcset = img.getAttribute('srcset');
        var src = img.getAttribute('src') || img.currentSrc || '';
        if (srcset) {
          img.setAttribute('srcset', srcset.trim());
        }
        if (src) {
          img.setAttribute('src', src);
        }
        if (typeof img.decode === 'function') {
          img.decode().catch(function () {});
        }
      }
    }

    function isSlideVisible(node) {
      if (!node || node.hidden) return false;
      if (node.classList.contains('media--multipack-hidden')) return false;
      return window.getComputedStyle(node).display !== 'none';
    }

    // Desktop (≥1024): theme ničí Flickity, galerie je CSS grid — DOM reorder/transform bliká.
    // Mobilní Flickity select jen pod 1024.
    function isMobileCarouselGallery(slider) {
      if (!slider || window.innerWidth >= 1024) return false;
      return (
        slider.classList.contains('flickity-enabled') ||
        !!slider.querySelector('.flickity-viewport')
      );
    }

    function findSlideByMediaId(slider, mediaId, multipackOnly) {
      if (mediaId == null) return null;
      var sel =
        '.product-single__media-slide[data-id="' +
        mediaId +
        '"]' +
        (multipackOnly === true
          ? '[data-multipack-only="true"]'
          : multipackOnly === false
            ? ':not([data-multipack-only])'
            : '');
      return slider.querySelector(sel);
    }

    function firstVisibleSlide(slider) {
      var slides = slider.querySelectorAll('.product-single__media-slide');
      for (var i = 0; i < slides.length; i++) {
        if (isSlideVisible(slides[i])) return slides[i];
      }
      return null;
    }

    function forceFlickityViewportHeight(flkty, selected) {
      if (!flkty || !flkty.viewport || !selected) return;
      var h = Math.round(selected.getBoundingClientRect().height) || selected.offsetHeight;
      if (h > 0) {
        flkty.viewport.style.height = h + 'px';
      }
    }

    function moveCellToFront(slider, selectEl) {
      if (!slider || !selectEl) return;
      var host = slider.querySelector('.flickity-slider') || slider;
      if (host.firstElementChild !== selectEl) {
        host.insertBefore(selectEl, host.firstElementChild);
      }
    }

    function syncDesktopGrid(slider, thumbs, selectSlide, selectThumb, isMp, mpSlides, mpThumbs) {
      if (window.innerWidth < 1024) return;
      if (!selectSlide) return;

      // Desktop = CSS grid bez Flickity. MP jsou na konci DOM → bez přesunu zůstanou pod foldem.
      moveCellToFront(slider, selectSlide);
      forceMediaImages(selectSlide);

      if (thumbs && selectThumb) {
        moveCellToFront(thumbs, selectThumb);
        forceMediaImages(selectThumb);
      }

      if (!isMp) {
        var host = slider.querySelector('.flickity-slider') || slider;
        mpSlides.forEach(function (slide) {
          host.appendChild(slide);
        });
        if (thumbs) {
          var thumbHost = thumbs.querySelector('.flickity-slider') || thumbs;
          mpThumbs.forEach(function (thumb) {
            thumbHost.appendChild(thumb);
          });
        }
      }
    }

    function refreshFlickity(slider, selectEl) {
      var flkty = getFlickityInstance(slider);
      if (!flkty) return false;

      if (selectEl) {
        forceMediaImages(selectEl);
        // Mobil: stejný index jako thumbs (asNavFor syncuje podle indexu, ne media id).
        if (window.innerWidth < 1024) {
          moveCellToFront(slider, selectEl);
        }
      }

      flkty.reloadCells();

      var idx = 0;
      var found = false;
      if (selectEl) {
        for (var i = 0; i < flkty.cells.length; i++) {
          if (flkty.cells[i].element === selectEl) {
            idx = i;
            found = true;
            break;
          }
        }
      }
      if (!found) {
        for (var j = 0; j < flkty.cells.length; j++) {
          if (isSlideVisible(flkty.cells[j].element)) {
            idx = j;
            found = true;
            break;
          }
        }
      }
      if (!found) {
        console.error('[multipack-gallery] Žádný viditelný slide pro Flickity select');
        return false;
      }

      flkty.select(idx, false, true);
      flkty.resize();
      forceFlickityViewportHeight(flkty, flkty.selectedElement || selectEl);

      requestAnimationFrame(function () {
        flkty.resize();
        forceFlickityViewportHeight(flkty, flkty.selectedElement || selectEl);
        var img = selectEl && selectEl.querySelector('img');
        if (img && !img.complete) {
          var onLoad = function () {
            img.removeEventListener('load', onLoad);
            flkty.resize();
            forceFlickityViewportHeight(flkty, flkty.selectedElement || selectEl);
          };
          img.addEventListener('load', onLoad);
        }
      });
      return true;
    }

    function refreshThumbsFlickity(thumbs, selectEl) {
      if (!thumbs) return;
      var flktyNav = getFlickityInstance(thumbs);
      if (!flktyNav) return;

      if (selectEl) {
        forceMediaImages(selectEl);
        if (window.innerWidth < 1024) {
          moveCellToFront(thumbs, selectEl);
        }
      }

      flktyNav.reloadCells();
      var idx = 0;
      if (selectEl) {
        for (var i = 0; i < flktyNav.cells.length; i++) {
          if (flktyNav.cells[i].element === selectEl) {
            idx = i;
            break;
          }
        }
      }
      flktyNav.select(idx, false, true);
      requestAnimationFrame(function () {
        flktyNav.resize();
        forceMediaImages(selectEl || flktyNav.selectedElement);
        var img = selectEl && selectEl.querySelector('img');
        if (img && !img.complete) {
          var onLoad = function () {
            img.removeEventListener('load', onLoad);
            flktyNav.resize();
          };
          img.addEventListener('load', onLoad);
        }
      });
    }

    /**
     * Theme balí Flickity do vendor.js jako window.themeVendor.Flickity.
     * Bez API nesmíme hýbat DOM (insertBefore) — rozbije interní stav carouselu.
     * Stačí odkrýt správný MP slide a přes Flickity.data vybrat + resize (adaptiveHeight).
     */
    function syncMultipackGallery(productEl, variant) {
      if (!productEl || !variant) return;
      var gallery = productEl.querySelector('[data-multipack-gallery="true"]');
      if (!gallery) return;

      var slider = gallery.querySelector('[data-product-single-media-slider]');
      var thumbs = gallery.querySelector('[data-product-single-media-thumbs]');
      if (!slider) return;

      var mpSlides = Array.prototype.slice.call(slider.querySelectorAll('[data-multipack-only="true"]'));
      var mpThumbs = thumbs
        ? Array.prototype.slice.call(thumbs.querySelectorAll('[data-multipack-only="true"]'))
        : [];
      if (mpSlides.length === 0) return;

      var isMp = isMultipackVariant(variant);
      var featuredId = mediaIdFromMap(gallery, variant);
      var productFeaturedId = productFeaturedMediaId(gallery);
      var showId = isMp ? featuredId : null;
      var selectSlide = null;
      var selectThumb = null;

      setMultipackVisibility(mpSlides, showId);
      setMultipackVisibility(mpThumbs, showId);

      if (isMp) {
        if (!featuredId) {
          console.error(
            '[multipack-gallery] Výhodné balení nemá featured_media na variantě',
            variant.id
          );
          return;
        }
        selectSlide = findSlideByMediaId(slider, featuredId, true);
        if (selectSlide) {
          selectSlide.hidden = false;
          selectSlide.classList.remove('media--multipack-hidden', 'media--hidden');
        } else {
          console.error('[multipack-gallery] Chybí slide pro media id', featuredId, 'variant', variant.id);
        }
        if (thumbs) {
          selectThumb = thumbs.querySelector(
            '[data-multipack-only="true"][data-id="' + featuredId + '"]'
          );
          if (selectThumb) {
            selectThumb.hidden = false;
            selectThumb.classList.remove('media--multipack-hidden');
          }
        }
      } else {
        // Běžné balení: vždy hlavní produktová fotka (ne variant.featured_media).
        selectSlide =
          findSlideByMediaId(slider, productFeaturedId, false) ||
          findSlideByMediaId(slider, productFeaturedId, null) ||
          firstVisibleSlide(slider);
        if (selectSlide) {
          selectSlide.classList.remove('media--hidden');
        }
        if (thumbs && selectSlide) {
          selectThumb = thumbs.querySelector(
            '.product-single__thumbnail[data-id="' + selectSlide.getAttribute('data-id') + '"]'
          );
        }
      }

      if (!selectSlide) {
        selectSlide = firstVisibleSlide(slider);
      }
      if (!selectSlide) {
        console.error('[multipack-gallery] Po sync není žádný viditelný slide', variant.id);
        return;
      }

      // Desktop grid: přesuň aktivní slide na začátek (jinak zůstane pod foldem).
      // Mobil: select + resize přes themeVendor.Flickity.
      if (getFlickityInstance(slider)) {
        refreshFlickity(slider, selectSlide);
        refreshThumbsFlickity(thumbs, selectThumb);
      } else {
        syncDesktopGrid(slider, thumbs, selectSlide, selectThumb, isMp, mpSlides, mpThumbs);
      }
    }

    document.addEventListener(
      'click',
      function (evt) {
        rememberScroll(resolveProductEl(evt.target));
      },
      true
    );
    document.addEventListener(
      'change',
      function (evt) {
        rememberScroll(resolveProductEl(evt.target));
      },
      true
    );

    document.addEventListener('theme:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      var productEl = resolveProductEl(evt.target);
      if (!productEl) return;

      // Theme volá updateProductImage AŽ PO tomto eventu a přepíše výběr slide.
      // Proto sync hned + znovu po krátkých delayích (desktop i mobil).
      syncMultipackGallery(productEl, variant);
      restoreScroll(productEl);

      [0, 50, 150, 300].forEach(function (delay) {
        setTimeout(function () {
          syncMultipackGallery(productEl, variant);
          restoreScroll(productEl);
        }, delay);
      });
    });

    function bootMultipackGalleries(attemptsLeft) {
      var foundPending = false;
      document.querySelectorAll('[data-product]').forEach(function (productEl) {
        var gallery = productEl.querySelector('[data-multipack-gallery="true"]');
        if (!gallery) return;
        var idInput = productEl.querySelector('input[name="id"]');
        var variantId = idInput && idInput.value;
        if (!variantId) return;
        var jsonEl = productEl.querySelector('[data-product-json]');
        if (!jsonEl) return;
        var product;
        try {
          product = JSON.parse(jsonEl.textContent);
        } catch (err) {
          console.error('[multipack-gallery] Neplatný Product JSON:', err);
          return;
        }
        var variant = (product.variants || []).find(function (row) {
          return String(row.id) === String(variantId);
        });
        if (!variant) return;
        syncMultipackGallery(productEl, variant);
        var slider = gallery.querySelector('[data-product-single-media-slider]');
        if (
          slider &&
          window.innerWidth < 1024 &&
          slider.classList.contains('flickity-enabled') &&
          !getFlickityInstance(slider)
        ) {
          foundPending = true;
        }
      });
      if (foundPending && attemptsLeft > 0) {
        setTimeout(function () {
          bootMultipackGalleries(attemptsLeft - 1);
        }, 120);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      bootMultipackGalleries(25);
    });
    window.addEventListener('load', function () {
      bootMultipackGalleries(10);
    });
  })();

  // PDP: discount badge na fotce jen u varianty, která má custom.applied_discount (ne u běžného balení).
  (function initDetailDiscountBadge() {
    function resolveProductEl(fromNode) {
      if (!fromNode) return null;
      if (fromNode.closest) {
        var direct = fromNode.closest('[data-product]');
        if (direct) return direct;
      }
      if (fromNode.querySelector) return fromNode.querySelector('[data-product]');
      return null;
    }

    function syncDetailDiscountBadge(productEl, variantId) {
      if (!productEl || !variantId) return;
      var mapEl = productEl.querySelector('[data-detail-discount-badge-map]');
      var badgeEl = productEl.querySelector('[data-detail-discount-badge]');
      if (!mapEl || !badgeEl) return;
      var map;
      try {
        map = JSON.parse(mapEl.textContent);
      } catch (err) {
        console.error('[detail-discount-badge] Neplatná mapa variant:', err);
        return;
      }
      var show = map[String(variantId)] === true;
      if (show) {
        badgeEl.hidden = false;
        badgeEl.removeAttribute('hidden');
      } else {
        badgeEl.hidden = true;
        badgeEl.setAttribute('hidden', '');
      }
    }

    document.addEventListener('theme:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      var productEl = resolveProductEl(evt.target);
      if (!productEl) return;
      syncDetailDiscountBadge(productEl, variant.id);
    });

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-product]').forEach(function (productEl) {
        var idInput = productEl.querySelector('input[name="id"], select[name="id"]');
        if (idInput && idInput.value) syncDetailDiscountBadge(productEl, idInput.value);
      });
    });
  })();

  /* Multipack group cards: size chips update preview; multi-size quick buy uses classic Quick View */
  (function initMultipackGroupCards() {
    function updateGroupCard(card, sizeBtn) {
      if (!card || !sizeBtn) {
        console.error('[multipack-group] Chybí card nebo size button');
        return;
      }

      var variantId = sizeBtn.getAttribute('data-variant-id');
      var variantUrl = sizeBtn.getAttribute('data-variant-url');
      var available = sizeBtn.getAttribute('data-available') === 'true';
      var price = sizeBtn.getAttribute('data-price') || '';
      var comparePrice = sizeBtn.getAttribute('data-compare-price') || '';
      var imageSrc = sizeBtn.getAttribute('data-image-src') || '';
      var imageSrcset = sizeBtn.getAttribute('data-image-srcset') || '';
      var imageAlt = sizeBtn.getAttribute('data-image-alt') || '';

      if (!variantId) {
        console.error('[multipack-group] Chybí data-variant-id');
        return;
      }

      card.querySelectorAll('[data-multipack-size]').forEach(function (btn) {
        var selected = btn === sizeBtn;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var input = card.querySelector('[data-multipack-variant-input]');
      if (input) input.value = variantId;

      var submit = card.querySelector('[data-multipack-atc]');
      if (submit) submit.disabled = !available;

      var quickView = card.querySelector('[data-multipack-quick-view]');
      if (quickView) {
        quickView.setAttribute('data-variant-id', variantId);
        if (variantUrl) quickView.setAttribute('href', variantUrl);
        if (available) {
          quickView.removeAttribute('aria-disabled');
          quickView.removeAttribute('tabindex');
        } else {
          quickView.setAttribute('aria-disabled', 'true');
          quickView.setAttribute('tabindex', '-1');
        }
      }

      card.classList.toggle('soldout', !available);

      var soldBadge = card.querySelector('[data-multipack-sold-badge]');
      if (soldBadge) {
        if (available) soldBadge.setAttribute('hidden', '');
        else soldBadge.removeAttribute('hidden');
      }

      card.querySelectorAll('[data-multipack-product-link]').forEach(function (link) {
        if (variantUrl) link.setAttribute('href', variantUrl);
      });

      var priceCurrent = card.querySelector('[data-multipack-price-current]');
      var priceCompare = card.querySelector('[data-multipack-price-compare]');
      if (priceCurrent && price) priceCurrent.textContent = price;
      if (priceCompare) {
        if (comparePrice) {
          priceCompare.textContent = comparePrice;
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }

      var discountLabel = sizeBtn.getAttribute('data-discount-label') || '';
      var discountBg = sizeBtn.getAttribute('data-discount-bg') || '';
      var discountFg = sizeBtn.getAttribute('data-discount-fg') || '';
      var badgeWrap = card.querySelector('[data-product-badge]');
      var discountBadge = badgeWrap
        ? badgeWrap.querySelector('.product__badge__item--discount-rule')
        : null;
      if (discountLabel || discountBg || discountFg) {
        if (!discountLabel || !discountBg || !discountFg) {
          console.error(
            '[multipack-group] Sleva varianty nemá kompletní badge',
            variantId,
            { label: discountLabel, bg: discountBg, fg: discountFg }
          );
        }
        if (!discountBadge && badgeWrap) {
          discountBadge = document.createElement('div');
          discountBadge.className = 'product__badge__item product__badge__item--discount-rule';
          discountBadge.appendChild(document.createElement('span'));
          var soldBadgeSlot = badgeWrap.querySelector('[data-multipack-sold-badge]');
          if (soldBadgeSlot) badgeWrap.insertBefore(discountBadge, soldBadgeSlot);
          else badgeWrap.appendChild(discountBadge);
        }
        if (discountBadge) {
          var badgeSpan = discountBadge.querySelector('span');
          if (!discountLabel) {
            if (badgeSpan) {
              badgeSpan.textContent =
                'Discount badge configuration error: metaobject `discount_rule.badge_text` is missing.';
            }
            discountBadge.style.backgroundColor = '';
            discountBadge.style.color = '';
          } else if (!discountBg) {
            if (badgeSpan) {
              badgeSpan.textContent =
                'Discount badge configuration error: metaobject `discount_rule.badge_background_color` is missing.';
            }
            discountBadge.style.backgroundColor = '';
            discountBadge.style.color = '';
          } else if (!discountFg) {
            if (badgeSpan) {
              badgeSpan.textContent =
                'Discount badge configuration error: metaobject `discount_rule.badge_text_color` is missing.';
            }
            discountBadge.style.backgroundColor = discountBg;
            discountBadge.style.color = '';
          } else if (badgeSpan) {
            badgeSpan.textContent = discountLabel;
            discountBadge.style.backgroundColor = discountBg;
            discountBadge.style.color = discountFg;
          }
          discountBadge.hidden = false;
          discountBadge.removeAttribute('hidden');
        }
      } else if (discountBadge) {
        discountBadge.hidden = true;
        discountBadge.setAttribute('hidden', '');
      }

      var unitPriceEl = card.querySelector('[data-multipack-unit-price]');
      var unitPrice = sizeBtn.getAttribute('data-unit-price') || '';
      if (unitPriceEl) {
        if (unitPrice) {
          unitPriceEl.textContent = unitPrice;
          unitPriceEl.hidden = false;
          unitPriceEl.removeAttribute('hidden');
        } else {
          unitPriceEl.textContent = '';
          unitPriceEl.setAttribute('hidden', '');
        }
      }

      if (imageSrc) {
        var imageWrap = card.querySelector('[data-multipack-image-wrap]');
        var img = imageWrap ? imageWrap.querySelector('img') : null;
        if (!img) {
          console.error('[multipack-group] Chybí img pro výměnu obrázku', variantId);
        } else {
          img.setAttribute('src', imageSrc);
          if (imageSrcset) img.setAttribute('srcset', imageSrcset);
          else img.removeAttribute('srcset');
          if (imageAlt) img.setAttribute('alt', imageAlt);
          img.classList.remove('is-loading');
        }
      }
    }

    document.addEventListener('click', function (event) {
      var sizeBtn = event.target.closest('[data-multipack-size]');
      if (!sizeBtn) return;
      var card = sizeBtn.closest('[data-multipack-group]');
      if (!card) return;
      event.preventDefault();
      updateGroupCard(card, sizeBtn);
    });
  })();

})();
